"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var lottie = require("lottie-web");
var Hero = /** @class */ (function () {
    function Hero() {
    }
    Hero.prototype.onLoadEach = function ($element) {
        if (!$element)
            return;
        var _a = $element.dataset.type, type = _a === void 0 ? "none" : _a;
        if (type !== "animation")
            return;
        var $animationContainer = $element.$(".animation");
        var _b = $animationContainer === null || $animationContainer === void 0 ? void 0 : $animationContainer.dataset, _c = _b.json, json = _c === void 0 ? "" : _c, _d = _b.loop, loop = _d === void 0 ? false : _d;
        if (json == "")
            return;
        var animation = lottie.loadAnimation({
            container: $animationContainer,
            renderer: "svg",
            loop: loop && loop == "true" ? true : false,
            autoplay: false,
            path: json
        });
        var intersectionOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0.7
        };
        var intersection = new IntersectionObserver(function (entries) {
            entries.map(function (entry) {
                if (entry.isIntersecting) {
                    animation.play();
                    intersection.unobserve(entry.target);
                }
            });
        }, intersectionOptions);
        intersection.observe($element);
        (0, DOMScript_1.getRefreshEvent$)().subscribe(function () {
            intersection.observe($element);
        });
    };
    Hero = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".HeroSection",
            isElementArray: true
        })
    ], Hero);
    return Hero;
}());
new Hero();
